module.exports = __webpack_public_path__ + "static/img/icon-4.798df70f.png";